import { getListWithArgs } from '../../services/list.service';
import {
  FETCH_ACTIVE_PROFILES_COUNT,
  FETCH_ALL_LISTS,
  FETCH_LIST_PAGINATION_SUCCESS,
  FETCH_LISTS_FOR_DROPDOWNS,
  FETCH_LISTS_REQUEST,
  FETCH_LISTS_SUCCESS,
  FETCH_LISTS_WITH_ACTIVE_PROFILES,
  LIST_ENRICHMENT_FINISHED,
  LIST_ENRICHMENT_STARTED,
} from './listTypes';

export const fetchListsRequest = () => {
  return {
    type: FETCH_LISTS_REQUEST,
  };
};

export const fetchListsSuccess = (lists) => {
  return {
    type: FETCH_LISTS_SUCCESS,
    payload: lists,
  };
};

export const fetchListPaginationSuccess = ({ data, count, key, evict = false }) => {
  return {
    type: FETCH_LIST_PAGINATION_SUCCESS,
    payload: { data, count, key, evict },
  };
};

export const fetchListsWithPagination =
  ({ listType, limit = 10, page = 1, cacheFirst = false, teamMemberIds = [] }) =>
  async (dispatch, state) => {
    let key;
    if (teamMemberIds.length > 0) {
      key = `${listType}-${limit}-${page}-${teamMemberIds.join('-')}`;
    } else {
      key = `${listType}-${limit}-${page}`;
    }

    if (cacheFirst && state()?.list?.list?.[key] !== undefined) return;

    dispatch(fetchListsRequest());
    const response = await getListWithArgs({
      isPaginatedRequest: true,
      listType,
      limit,
      page,
      teamMemberIds,
    });
    if (response?.status) {
      dispatch(
        fetchListPaginationSuccess({
          key,
          data: response?.data?.lists,
          count: response?.data?.totalPages,
          evict: false,
        })
      );
    }
  };

export const fetchAllLists = (headers) => async (dispatch, state) => {
  const response = await getListWithArgs(
    {
      fields: ['_id', 'name', 'influencers', 'lastAddedByDiscoveryAt'],
      listType: 'active',
    },
    headers
  );
  if (response?.status) {
    dispatch({ type: FETCH_ALL_LISTS, payload: response?.data?.lists });
    dispatch({ type: FETCH_LISTS_FOR_DROPDOWNS, payload: response?.data?.lists?.slice(0, 10) });
  }
};

export const fetchAllListsWithActiveProfiles = (headers) => async (dispatch, state) => {
  const response = await getListWithArgs(
    {
      fields: ['_id', 'name', 'influencers'],
      listType: 'active',
      filterByActive: true,
    },
    headers
  );
  if (response?.status) {
    dispatch({ type: FETCH_LISTS_WITH_ACTIVE_PROFILES, payload: response?.data?.lists });
    dispatch({ type: FETCH_ACTIVE_PROFILES_COUNT, payload: response?.data?.activeCount ?? 0 });
  }
};

export const evictAndFetchList =
  ({ listType = 'active', limit = 10, page = 1 } = { listType: 'active', limit: 10, page: 1 }) =>
  async (dispatch, state) => {
    const key = `${listType}-${limit}-${page}`;
    dispatch(fetchListsRequest());
    dispatch(fetchAllLists());
    const response = await getListWithArgs({ isPaginatedRequest: true, listType, limit, page });
    if (response?.status) {
      dispatch(
        fetchListPaginationSuccess({ key, data: response?.data?.lists, count: response?.data?.totalPages, evict: true })
      );
    }
  };

export const listEnrichmentStarted = (listId) => {
  return {
    type: LIST_ENRICHMENT_STARTED,
    payload: listId,
  };
};

export const listEnrichmentFinished = (listId) => {
  return {
    type: LIST_ENRICHMENT_FINISHED,
    payload: listId,
  };
};
